import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import ToggleModeDarkLight from '@/shared-components/toggles/ToggleModeDarkLight';

import OnBoardingSlider from './OnBoardingSlider';

import './styles/OnBoardingLayout.scss';

export default function OnBoardingLayout({ user_type }) {
  return (
    <>
      <div className="onboarding-layout__container">
        {/* Header fijo arriba */}
        <div className="onboarding-layout__header">
          <SuarteName className="onboarding-layout__suarte-name" />
          <ToggleModeDarkLight className="onboarding-layout__theme-toggle" />
        </div>

        {/* Card central con el slider */}
        <div className="onboarding-layout__card">
          <OnBoardingSlider user_type={user_type} />
        </div>
      </div>
    </>
  );
}
